
import React from 'react';
import { Grid, Typography } from '@mui/material';
import './CallAnalysisOverview.css';
import aiOverviewImg from '../../assests/Pages/CallAnalysis/ca_overview_img.png';
import PurpleArrowIcon from '../../assests/Pages/CallAnalysis/arrow_ca_overview.png';
import chronox_overviewlogo from "../../assests/Pages/CallAnalysis/chronox_overviewlogo.png"
const CallAnalysisOverview = () => {
  const bulletPoints = [
    'Designed for precision, this AI-powered tool transcribes calls, evaluates performance, and analyzes tone to enhance customer engagement.',
    'Leverage AI-driven insights to enhance customer interactions, optimize agent performance, and ensure compliance with industry standards.',
    'Stay ahead with AI-driven call analysis—enhancing communication, customer satisfaction, and business success.',
  ];

  return (
    <Grid container className="ai-overview-main-container" justifyContent="center" alignItems={"center"} height={{md:"auto", lg:"100vh"}}>
      <Grid item xs={12} sm={11} md={10} lg={10} xl={9}>
        <Grid container className="overview-gap" flexWrap={{ lg: "nowrap", xs: "wrap" }} justifyContent={"space-between"} display={"flex"}>
          <Grid item xs={12} md={12} className="ai-overview-left">
            <Grid container className="overview-gap" >
                <Grid item xs={12} lg={10} xl={8.5}>
                    <h3 className="ai-overview-heading">
                      Transform Call Analysis with AI-Driven Intelligence
                    </h3>
                </Grid>
                <Grid item xs={12} md={12} lg={11} xl={9}>
                    <Grid container direction="column" spacing={2}>
                      {bulletPoints.map((point, index) => (
                        <Grid item container key={index} spacing={1} alignItems="flex-start">
                            <Grid item>
                                <img src={PurpleArrowIcon} alt="bullet" className="ai-bullet-icon" />
                            </Grid>
                            <Grid item xs>
                                <Typography className="ai-overview-point">{point}</Typography>
                            </Grid>
                        </Grid>
                      ))}
                    </Grid>
                </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={12} xl={12} className="ai-overview-right">
            <img src={aiOverviewImg} alt="AI Call Analysis" className="ai-overview-image"/>
          </Grid>
        </Grid>
                
      </Grid>
        <img src={chronox_overviewlogo} alt="Chronox Logo" className="ai-bottom-right-logo"/>
    </Grid>
  );
};

export default CallAnalysisOverview;

